import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseRemoveShopStoreParams = {
	shopId: string;
	storeId: string;
};

export default function useRemoveShopStore({
	shopId,
	storeId,
}: UseRemoveShopStoreParams) {
	const invalidateShop = useInvalidateShop(shopId);

	return useApiMutation<"delete", "/shops/{shopId}/return-to-store/stores/{storeId}", void>(
		"delete",
		"/shops/{shopId}/return-to-store/stores/{storeId}",
		{
			invalidate: invalidateShop,
			mapVariables: () => ({
				params: { path: { storeId, shopId } },
			}),
		},
	);
}
